/**
 * Parse a raw input value for a number field.
 * Preserves empty string so the field can be visually cleared;
 * invalid input also falls back to empty string.
 */
export function parseNumericInput(value) {
  if (value === "") return "";
  const num = Number(value);
  return isNaN(num) ? "" : num;
}

/**
 * Coerce a number field value to a numeric type for the API payload.
 * Empty string is treated as 0 so the backend always receives a number.
 */
export function coerceNumericPayload(value) {
  return value === "" ? 0 : value;
}

/**
 * Returns true if required invoice form fields are missing.
 * Checked before any early-return logic in isSaveDisabled so required
 * fields are always enforced, even for auto-rejected invoices.
 */
export function isInvoiceRequiredFieldsMissing(values) {
  if (values.invoice_value === "" || values.invoice_value == null) return true;
  if (values.invoice_image === "" || values.invoice_image === null) return true;
  return false;
}
